import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { ISubmittals } from "../../../models/Submittals";
import { baseUrl } from "../../../shared/Fetch";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";

interface IProps {
    singleData: ISubmittals,
    hideDialog: () => void,
    open: boolean,
    toast: any
}

export const RecruiterUnderstandingForm = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: any[], loading: boolean });
    const [viewAudioF, setViewAudioF] = useState(false);
    const [viewAudioS, setViewAudioS] = useState(false);

    const onHide = () => {
        setTableData({ tableData: [], loading: false });
        setViewAudioF(false);
        setViewAudioS(false);
        props.hideDialog();
    }

    useEffect(() => {
        if (props.open) setTableData({ tableData: [props.singleData], loading: false });
        if (props.open && props.singleData.understood_Audio_Path && props.singleData.understood_Audio_Path !== null && props.singleData.understood_Audio_Path?.trim() !== "") {
            setViewAudioF(true);
        }
        if (props.open && props.singleData.notUnderstood_Audio_Path && props.singleData.notUnderstood_Audio_Path !== null && props.singleData.notUnderstood_Audio_Path?.trim() !== "") {
            setViewAudioS(true);
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Recruiter Requirement Understanding" className="p-fluid" maximizable onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                stripedRows showGridlines responsiveLayout="scroll"
                value={tableData.tableData}
                loading={tableData.loading}
            >
                <Column field="req_Understand_Percentage" header="Understanding %" />
                <Column field="req_Understood_Comment" header="What Understood" body={(rowData: any) => <div className="knob" style={{ height: "20px", width: "150px", overflow: "hidden", textOverflow: "ellipsis" }}>{rowData.req_Understood_Comment}<Tooltip target=".knob" position="top" content={`${rowData.req_Understood_Comment}`} /></div>} />
                <Column field="understood_Audio_Path" header="What Understood Audio" body={(rowData: ISubmittals) => {
                    if (viewAudioF === true) {
                        return <audio controls style={{ width: '100%' }}>
                            <source src={baseUrl + `Calling_Extension/streamReqUnderstandingAudio2?subID=${props.singleData.submission_id}&fileName=${rowData.understood_Audio_Path}`} type="audio/webm" />
                            Your browser does not support the audio element.
                        </audio>
                    } else return <></>

                }} />
                <Column field="req_NotUnderstood_Comment" header="What Not Understood" body={(rowData: any) => <div className="knob2" style={{ height: "20px", width: "150px", overflow: "hidden", textOverflow: "ellipsis" }}>{rowData.req_NotUnderstood_Comment}<Tooltip target=".knob2" position="top" content={`${rowData.req_NotUnderstood_Comment}`} /></div>} />
                <Column field="notUnderstood_Audio_Path" header="What Not Understood Audio" body={(rowData: ISubmittals) => {
                    if (viewAudioS === true) {
                        return <audio controls style={{ width: '100%' }}>
                            <source src={baseUrl + `Calling_Extension/streamReqUnderstandingAudio2?subID=${props.singleData.submission_id}&fileName=${rowData.notUnderstood_Audio_Path}`} type="audio/webm" />
                            Your browser does not support the audio element.
                        </audio>
                    } else return <></>
                }} />
            </DataTable>
        </Dialog>
    );
}